import React, { useState , useEffect} from 'react';
import { useNavigate , useParams } from 'react-router-dom';
import { ToastContainer , toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { editTrustScore , singleTrustScore} from '../../../../services/trustScore/trustScoreService';
import FormEditBlog from '../../../common/forms/FormEditBlog';
import Loading from '../../../common/loading/Loading';


const EditCoin
 = () => {

    const {id} = useParams();

    const navigate = useNavigate();

    const[loading , setLoading] = useState(true);
    const [loadingForm , setLoadingForm] = useState(false);
    const [ form , setForm ]= useState();
    const [ coin , setCoin ]= useState({});
    

    useEffect(()=>{
        try{

            const getCoin = async()=>{

                const res = await singleTrustScore(id);
    
                setLoading(false);
    
                if(res.data.status === 'success'){
                    setCoin(res.data.data.coin);
                    setForm( {
                        formItems: [
                        {
                            inputType: "input",
                            config: {
                                label: 'Title',
                                name: "title",
                                containerClasses : 'w-full'
                            },
                            value: res.data.data.coin.title,
                            validation: {
                                required: true,
                            },
                            valid: false,
                            errorMsg: "",
                            used: false
                        },
                        {
                            inputType: "input",
                            config: {
                                label: 'H1',
                                name: "h1",
                                containerClasses : 'w-full'
                            },
                            value: res.data.data.coin.h1,
                            validation: {
                                required: true,
                            },
                            valid: false,
                            errorMsg: "",
                            used: false
                        },
                        {
                            inputType: "input",
                            config: {
                                label: 'Blog Header',
                                name: "blogHeader",
                                containerClasses : 'w-full'
                            },
                            value: res.data.data.coin.blogHeader,
                            validation: {
                                required: true,
                            },
                            valid: false,
                            errorMsg: "",
                            used: false
                        },
                        {
                            inputType: "input",
                            config: {
                                label: 'Slug',
                                name: "slug",
                                containerClasses : 'w-full'
                            },
                            value: res.data.data.coin.slug,
                            validation: {
                                required: true,
                            },
                            valid: false,
                            errorMsg: "",
                            used: false
                        },
                        {
                            inputType: "input",
                            config: {
                                label: 'Seo Description',
                                name: "seoDesc",
                                containerClasses : 'w-full'
                            },
                            value: res.data.data.coin.seoDesc,
                            validation: {
                                required: true,
                            },
                            valid: false,
                            errorMsg: "",
                            used: false
                        },
                        {
                            inputType: "textarea",
                            config: {
                                label: 'Keywords',
                                name: "keywords",
                                containerClasses : 'w-full'
                            },
                            value: res.data.data.coin.keywords,
                            validation: {
                                required: true,
                            },
                            valid: false,
                            errorMsg: "",
                            used: false
                        },
                        {
                            inputType: "ck-editor",
                            config: {
                                label: 'Body',
                                name: "body",
                                containerClasses : 'w-full'
                            },
                            value: res.data.data.coin.body,
                            validation: {
                                required: true,
                            },
                            valid: false,
                            errorMsg: "",
                            used: false
                        },
                        {
                            inputType: "input-file",
                            config: {
                                label: 'Image',
                                name: "images",
                                type: "file",
                                t_label : 'attached_file',
                                containerClasses : 'w-1/2'
                            },
                            value: "",
                            validation: {
                                maxSize: 5000000,
                            },
                            valid: false,
                            errorMsg: "",
                            used: false
                        },
                        {
                            inputType: "input",
                            config: {
                                label: 'faq Title',
                                name: "faqTitle",
                                containerClasses : 'w-full'
                            },
                            value:  res.data.data.coin.faqTitle,
                            validation: {
                            },
                            valid: false,
                            errorMsg: "",
                            used: false
                        },
                        {
                            inputType: "faq",
                            config: {
                                label: 'AFQ',
                                name: "faq",
                                containerClasses : 'w-full'
                            },
                            value: res.data.data.coin.faq,
                            validation: {
                            },
                            valid: false,
                            errorMsg: "",
                            used: false
                        },
                    ]
                    });
    
                }else if(res.data.status === 'error'){
                    toast.error(res.data.msg);
                }
                setLoading(false);
            }
            getCoin();

        }catch(err){
            setLoading(false);
            toast.error("something wrong")
        }
    } , []);
        


    const handleSubmitForm = async(formData)=>{

        try {
            setLoadingForm(true);
            const {data} = await editTrustScore(id , formData);
            setLoadingForm(false); 
            if(data.status === 'success'){
                toast.success('This post edited successfull');
                navigate('/trust-score')
    
            }else if(data.status == 'error'){
                toast.error(data.msg);
            }
        } catch (err) {
            setLoadingForm(false);
            toast.error(err.response?.data?.msg ?? err.response?.data?.message ?? 'something went wrong');
        }
    }



    return (
        <>
            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />


            <div className="container mx-auto p-3 ">
                <div className='bg-white-100 dark:bg-dark-100 p-3 rounded-md text-[0.9rem] font-normal flex flex-col justify-center items-start shadow-my dark:shadow-none '>
                    <div className='w-full flex justify-start items-center mb-5'>
                        <svg className='w-2 h-2 fill-gray-700 dark:fill-white-100 mr-2' viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="50" />
                        </svg>
                        <span className='text-gray-700 dark:text-white-100 text-xl font-extrabold'>Edit Coin</span>
                    </div>
                    {
                        loading ? 
                        (
                            <Loading/>
                        )
                        :
                        (
                            <FormEditBlog initForm={form} submit={handleSubmitForm} loading={loadingForm} submitTitle="Apply" file={true} post={coin}/>
                        )
                    }

                </div>
            </div>
        </>
    )

}

export default EditCoin
 ;
